import { FC, memo } from "react";

interface SectionHeaderTitleProps {
    children: React.ReactNode;
    design?: string;
    className?: string;
}

const SectionHeaderTitle: FC<SectionHeaderTitleProps> = ({ children, design = "default", className }) => {

    const classes = {
        default: "flex flex-row items-center gap-x-2 w-full",
        divider: "flex flex-row items-center gap-x-2 w-full text-center",
    }[design] || design;

    switch (design) {
        case "divider":
            return (
                <div className={`${classes} ${className}`}>
                    <div className="border-b border-gray-300 w-full"></div>
                    {children}
                    <div className="border-b border-gray-300 w-full"></div>
                </div>
            )
        default:
            return (
                <div className={`${classes} ${className}`}>
                    {children}
                </div>
            )
    }

}

export default memo(SectionHeaderTitle)

